import React, { useContext, useState } from "react";
import { Tabs, Tab } from "@mui/material";
import { useStyles } from "../styles/MainContainerStyles";
import { FormHeading } from "../utils/CommonComonents/FormHeading";
import { getUserFromCache } from "../user/UserCommon";

import { useNavigate, useLocation, Outlet, Link } from "react-router-dom";

import isFeatureGated from "../modules/FeatureGatingModule";
import FeatureGateDialog from "../components/FeatureGateDialog";
import StarsIcon from "@mui/icons-material/Stars";

import { useTheme } from "@mui/material";

const ServicePageTabs = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const classes = useStyles();
    const user = getUserFromCache();

    const theme = useTheme();

    const selectedTab = location.pathname.includes("/locations")
        ? "/services/locations"
        : location.pathname.includes("/skills")
          ? "/services/skills"
          : location.pathname.includes("/packages")
            ? "/services/packages"
            : location.pathname.includes("/promo-codes")
              ? "/services/promo-codes"
              : location.pathname.includes("/regional-pricing")
                ? "/services/regional-pricing"
                : "/services";

    const [showFeatureGateDialog, setShowFeatureGateDialog] = useState(false);

    const regionalPricingFeatureGated = isFeatureGated(
        user.company.subscriptionLevel,
        "RegionalPricing"
    );

    const handleOnClose = () => {
        setShowFeatureGateDialog(false);
    };

    return (
        <>
            <FormHeading
                id="MBServicesForm"
                title={"Services"}
                classes={classes}
            />
            <Tabs
                value={selectedTab}
                indicatorColor="primary"
                textColor="primary"
                sx={{ "& :hover": { color: theme.palette.text.secondary } }}
            >
                <Tab
                    value="/services"
                    component={Link}
                    to={"/services"}
                    label="Services"
                />
                <Tab
                    value="/services/skills"
                    component={Link}
                    to={"skills"}
                    label="Skills"
                />
                <Tab
                    value="/services/locations"
                    component={Link}
                    to={"locations"}
                    label="Locations"
                />
                <Tab
                    value="/services/packages"
                    component={Link}
                    to={"packages"}
                    label="Packages"
                />
                <Tab
                    value="/services/promo-codes"
                    component={Link}
                    to={"promo-codes"}
                    label="Promo Codes"
                />
                <Tab
                    value="/services/regional-pricing"
                    component={!regionalPricingFeatureGated && Link}
                    to={!regionalPricingFeatureGated && "regional-pricing"}
                    label="Regional Pricing"
                    icon={
                        regionalPricingFeatureGated && (
                            <StarsIcon color="notice" />
                        )
                    }
                    iconPosition="end"
                    onClick={() => {
                        if (regionalPricingFeatureGated) {
                            setShowFeatureGateDialog(true);
                        } else {
                            navigate("regional-pricing");
                        }
                    }}
                ></Tab>
            </Tabs>
            <FeatureGateDialog
                open={showFeatureGateDialog}
                handleOnClose={handleOnClose}
            />
            <Outlet />
        </>
    );
};

export default ServicePageTabs;
